// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"InfoAddPaymentModal_tooltip__RD3e4","root":"InfoAddPaymentModal_root__De2gd","label":"InfoAddPaymentModal_label__ay8el","input":"InfoAddPaymentModal_input__Rk_zQ"};